export enum SDPReadingNicheEnum {
  MANDATORY = 'MANDATORY',
  OPTIONAL = 'OPTIONAL',
}
